import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, OnInit, inject, input } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { IEndpoint, INetworkQualityReportEvent } from "@auvious/rtc";
import { ConferenceService, isDebugOn } from "../../services";
import { zoomInOut } from "../../core-ui.animations";
import { TileComponent } from "../tile/tile.component";

@Component({
  selector: "app-network-indicator",
  templateUrl: "./network-indicator.component.html",
  styleUrls: ["./network-indicator.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [zoomInOut],
  standalone: false,
})
export class NetworkIndicatorComponent implements OnInit {
  private conferenceService = inject(ConferenceService);
  private cdr = inject(ChangeDetectorRef);
  private tile = inject(TileComponent, { optional: true });
  private destroyRef = inject(DestroyRef);

  readonly endpoint = input<string>(undefined);

  private report: INetworkQualityReportEvent;

  ngOnInit() {
    this.conferenceService.networkQualityReport$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((report) => {
        this.report = report;
        this.cdr.detectChanges();
      });
  }

  get isVisible() {
    return true; /*!!this.quality;*/
  }

  get position() {
    return !!this.tile ? "right" : "bottom";
  }

  get quality() {
    return (
      this.report?.participantIndicatorMap[this.endpoint()] || {
        averageJitter: 0,
        averageNetworkQuality: 100,
        averageRtt: 0,
        grade: "OPTIMAL",
      }
    );
  }

  get isDebug() {
    return isDebugOn();
  }

  get isGood() {
    return (
      !this.quality || (!!this.quality && this.quality.grade === "OPTIMAL")
    );
  }

  get isLow() {
    return !!this.quality && this.quality.grade === "SUBOPTIMAL";
  }

  get isBad() {
    return !!this.quality && this.quality.grade === "BAD";
  }

  get jitter() {
    return !this.quality
      ? "n/a"
      : this.quality.averageJitter > 0
      ? this.quality.averageJitter
      : "0";
  }

  get packetLoss() {
    return !!this.quality ? 100 - this.quality.averageNetworkQuality : "0";
  }

  get rtt() {
    return !this.quality
      ? "n/a"
      : this.quality.averageRtt > 0
      ? this.quality.averageRtt
      : "0";
  }
}
